import { showPassword, hidePassword } from '../utilities/utility';
import { API_REFERENCE } from '../utilities/constant_api';
import { formPostJsonResponse, htmlPost } from '../components/ajax';

$(function() {
  const jPwdResetFormCls = '.reset-password__jform';
  const jPwdUnmCls = '.reset-password__jusername';
  const jPwdPd = '.reset-password__jpd';
  const updatePwdFormSelector = '#updatePwdForm';
  const updatePwdConfirm = '.confirm-new-password';
  let resetResendEmailAjaxReq = true;
  let resetPwdSubmitAjaxReq = true;
  $('#pwdTooltip').tooltip({
    title: createTooltipContent(),
    html: true
  });

  function createTooltipContent() {
    toolTipBodyPwdText = toolTipBodyPwdText || '';
    let numberOfOptions = toolTipBodyPwdText.split(';');
    let txt1 = `<div class="text-left">${toolTipHeaderPwdText}</div>`;
    let txt3 = `<div class="text-left pt-2">${toolTipFooterPwdText}</div>`;
    let txt2 = '<ul>';
    $.each(numberOfOptions, function(index, value) {
      txt2 += '<li>' + value + '</li>';
    });
    txt2 += '</ul>';
    tooltipContent = txt1 + txt2 + txt3;
    return tooltipContent;
  }

  function toggleForgetPwd() {
    const requiredSelector = $(this)
      .parent()
      .siblings('.passwordfield');
    const passwordType = requiredSelector.attr('type');
    if (passwordType === 'text') {
      hidePassword(requiredSelector);
    } else {
      showPassword(requiredSelector);
    }
  }

  function confirmPasswordValidation() {
    let isValidate = true;
    var passw = /^(?=.{8,})(?=.*[a-z])(?=.*\d)(?=.*[A-Z])(?=.*[!#$%&’"*+,-.:;<=>?@^_`'\)~\(\[\]\{\}\|\\\/]).*$/; 
    var password = $('.new-password').val();

    if (password.length > 0) {
      if (!password.match(passw)) {
        $('.error-msg-reset-pass').removeClass('hidden');
        $('#newPassword').addClass('error');
        isValidate = false;
      } else {
        $('.error-msg-reset-pass').addClass('hidden');
        $('#newPassword').removeClass('error');
        isValidate = true;
      }
    }
    return isValidate;
  }

  function enableEmailSubmitButton() {
    var value = $(this).val();

    if (value.length > 0) {
      $('.email-details .submit-btn').attr('disabled', false);
    } else {
      $('.email-details .submit-btn').attr('disabled', true);
    }
  }

  function enableSecurityAnsSubmitButton() {
    var value = $(this).val();

    if (value.length > 3) {
      $('.security-question .submit-btn').attr('disabled', false);
    } else {
      $('.security-question .submit-btn').attr('disabled', true);
    }
  }

  function securityAnsReqdMsg() {
    var value = $(this).val();

    if (value < 1) {
      $('.security-answer__reqd').removeClass('hidden');
      $(this).addClass('error');

      if (!$('.security-answer__incorrect-ans').hasClass('hidden')) {
        $('.security-answer__incorrect-ans').addClass('hidden');
      }
    } else {
      $(this).removeClass('error');
      $('.security-answer__reqd').addClass('hidden');
    }
  }

  function pwdReqd() {
    var id = $(this).attr('id');
    var val = $(this).val();
    $(this)
      .closest('.confirm-new-pwd')
      .find('.error-msg-text')
      .addClass('hidden');
    if (val.length < 1) {
      $(this).addClass('error');
      if (id === 'newPassword') {
        $('.new-pwd__reqd').removeClass('hidden');
      } else {
        $('.confirm-new-pwd__reqd').removeClass('hidden');
      }
    } else if (val.length > 0) {
      if (id === 'newPassword') {
        $('#newPassword').removeClass('error');
        if (!$('.new-pwd__reqd').hasClass('hidden')) {
          $('.new-pwd__reqd').addClass('hidden');
        }
      } else if (id === 'confirmNewPassword') {
        if ($('.confirm-new-pwd__mismatch').hasClass('hidden')) {
          $('#confirmNewPassword').removeClass('error');
        }
        if (!$('.confirm-new-pwd__reqd').hasClass('hidden')) {
          $('.confirm-new-pwd__reqd').addClass('hidden');
        }
      }
    }
  }

  function checkWhetherPwdsMatch(e) {
    var newPwdVal = $('#newPassword').val();
    var confirmPwdVal = $('#confirmNewPassword').val();
    var isButton = $(this).hasClass('submit-btn');
    if (newPwdVal.length > 0 && confirmPwdVal.length > 0) {
      if (newPwdVal !== confirmPwdVal) {
        $('#confirmNewPassword').addClass('error');
        $('.confirm-new-pwd__mismatch').removeClass('hidden');
        $('.resetpassword-btns .submit-btn').attr('disabled', true);
      } else {
        $('#confirmNewPassword').removeClass('error');

        if (!$('.confirm-new-pwd__mismatch').hasClass('hidden')) {
          $('.confirm-new-pwd__mismatch').addClass('hidden');
        }

        $('.resetpassword-btns .submit-btn').attr('disabled', false);
        if (isButton) {
          submitChangePasswordForm();
        }
      }
    }
  }

  function validatePasswordComplexity(){
    let isValidate = true;
    let searchParams = new URLSearchParams(window.location.search);
    const pwd = $('#newPassword').val();
    const email = searchParams.get('emailId');
    const emailParts = email.split(/[#@.,_-]/);
    for(const part of emailParts){
      if(part.length > 3 && pwd.toLowerCase().includes(part)){
        $('#newPassword').addClass('error');
        $('#confirmNewPassword').addClass('error');
        $('.error-msg-reset-pass').removeClass('hidden');
        isValidate = false;
        break;
      }   
    }
    return isValidate;
  }

  // overriding enter key from calling default submit method. Instead, route it to the Submit button click if not disabled.
  $(document).on('keypress', '#pwd-sec-question-form', function(e) {
    var key = e.charCode || e.keyCode || 0;
    if (key == 13) {
      e.preventDefault();

      if (!$('#pwd-sec-question-form .submit-btn').is('[disabled]')) {
        $('#pwd-sec-question-form .submit-btn').click();
      }
    }
  });

  function submitChangePasswordForm() {
    const jpwdResetForm = $(jPwdResetFormCls);
    const jusername = jpwdResetForm.find(jPwdUnmCls);
    const jpd = jpwdResetForm.find(jPwdPd);
    const confirmPd = $(updatePwdFormSelector).find(updatePwdConfirm);
    const formURL = `${ACC.config.encodedContextPath}${API_REFERENCE.resetPassword.submitNewPwd}`;
    const formSerialized = $('#updatePwdForm').serialize();
    if (!resetPwdSubmitAjaxReq) return false;
    resetPwdSubmitAjaxReq = false;
    if(validatePasswordComplexity() && confirmPasswordValidation()){
    formPostJsonResponse(formURL, formSerialized)
      .then(responseData => {
        resetPwdSubmitAjaxReq = true;
        const response = $.extend({}, responseData);
        if (!$('.password-details__error').hasClass('hidden')) {
          $('.password-details__error').addClass('hidden');
        }
        if (response.status == 'SUCCESS') {
          $('.password-details__success').removeClass('hidden');
          jusername.val(responseData.emailId);
          jpd.val(confirmPd.val());
          jpwdResetForm.submit();
        } else {
          $('#updatePwdForm .error-submit-msg').remove();
          if (response.errorcode == 'BindingResultsError') {
            response.result.forEach(function(item) {
              if (item.code !== null) {
                $("#updatePwdForm [name='" + item.field + "']").addClass(
                  'error'
                );
                $(
                  "<div class='error-submit-msg'>" + item.code + '</div>'
                ).insertAfter("#updatePwdForm [name='" + item.field + "']");
              }
            });
          } else {
            $('.password-details__error')
              .removeClass('hidden')
              .find('.password-details__error-msg')
              .text(response.errormessage);
          }
        }
      })
      .catch(error => {
        resetPwdSubmitAjaxReq = true;
      });
    } else {
      resetPwdSubmitAjaxReq = true;
    }
  }

  function enablesecurityAnswerSubmit() {
    var text = $('#securityAnswer').val();
    if (text) {
      if (text.length > $('#securityAnswer').attr('data-minLength')) {
        $('.security-question .submit-btn').attr('disabled', false);
      } else {
        $('.security-question .submit-btn').attr('disabled', true);
      }
    }
  }

  function showHidePwdIcon() {
    if ($(this).val().length > 0) {
      $(this)
        .parent()
        .find('.showhide-field')
        .removeClass('hidden');
    } else {
      $(this)
        .parent()
        .find('.showhide-field')
        .addClass('hidden');
    }
  }

  function onClickResendEmailLink(e) {
    e.preventDefault();
    let searchParams = new URLSearchParams(window.location.search);
    const emailId = encodeURIComponent(searchParams.get('email'));
    const requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.resetPwd.resendEmail}?email=${emailId}`;
    if (!resetResendEmailAjaxReq) return false;
    resetResendEmailAjaxReq = false;
    htmlPost(requestURL)
      .then(responseData => {
        resetResendEmailAjaxReq = true;
      })
      .catch(error => {
        resetResendEmailAjaxReq = true;
      });
  }
  $('.email-details .email-address').on('input', enableEmailSubmitButton);
  $('#securityAnswer')
    .on('input', enableSecurityAnsSubmitButton)
    .on('blur', securityAnsReqdMsg);
  $('#newPassword,#confirmNewPassword').on('input', showHidePwdIcon);
  $('#newPassword,#confirmNewPassword').on('input click blur', pwdReqd);
  $('#confirmNewPassword').on('input click blur', checkWhetherPwdsMatch);
  $('#newPassword').on('input click blur', confirmPasswordValidation);
  $('.new-password-field #newPassword').on(
    'input click blur',
    checkWhetherPwdsMatch
  );
  //Submit buttons click
  $('#updatePwdForm .submit-btn').on('click', checkWhetherPwdsMatch);
  //$('#updatePwdForm .submit-btn').on('click', validatePasswordComplexity);
  // reomving event listeners not required as pages not present after MFA
  $('#resend-email-link').on('click', onClickResendEmailLink);
  //show hide password
  $('.js-toggling').on('click', toggleForgetPwd);
  $(document).ready(enablesecurityAnswerSubmit);
    $(document).on('blur',"#newPassword",passwordValidationForInstruction);

    function passwordValidationForInstruction(){

        const createNewPasswordValue = $("#newPassword").val();
        const passwordMessageItems = document.getElementsByClassName("password-message-item")

        patternCheck(passwordMessageItems[1],/[0-9]/g,createNewPasswordValue);
        patternCheck(passwordMessageItems[2],/[A-Z]/g,createNewPasswordValue);
        patternCheck(passwordMessageItems[3],/[a-z]/g,createNewPasswordValue);
        patternCheck(passwordMessageItems[4],/[!#$%&’*+,-.:;<=>?@^_`\)~\(\[\]\{\}\|\\\/\""'']/,createNewPasswordValue);

        // Checking length of the password
        if (createNewPasswordValue.length >= 8 && createNewPasswordValue.length <= 25) {
            passwordMessageItems[0].classList.remove("invalid")
            passwordMessageItems[0].classList.add("valid")
        } else {
            passwordMessageItems[0].classList.remove("valid");
            passwordMessageItems[0].classList.add("invalid");
            $(".password-message").removeClass("d-none");
        }
    }

    function patternCheck(passwordMessageItem,regexPattern,createNewPasswordValue){
        if (createNewPasswordValue.match(regexPattern)) {
            passwordMessageItem.classList.remove("invalid")
            passwordMessageItem.classList.add("valid")
        } else {
            passwordMessageItem.classList.remove("valid");
            passwordMessageItem.classList.add("invalid");
            $(".password-message").removeClass("d-none");
        }
    }
});
